"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePodInformation = void 0;
var parsePodInformation = function (data) {
    return {
        podConnection: data.getUint8(0),
        podType: data.getUint8(1),
        podUid: data.podUid,
        liquidFlavor: data.getUint16(3),
        podCapacity: data.getUint8(4),
        liquidNicotineStrength: data.getUint16(5),
        volumeOfLiquidRemaining: data.getUint16(6),
    };
};
exports.parsePodInformation = parsePodInformation;
